/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1PecegepayTransferCoursefinpersonpaymentid200,
  PostApiV1PecegepayTransferCoursefinpersonpaymentid401,
  PostApiV1PecegepayTransferCoursefinpersonpaymentid500,
  PostApiV1PecegepayTransferCoursefinpersonpaymentidMutationResponse,
  PostApiV1PecegepayTransferCoursefinpersonpaymentidPathParams,
} from "../../types/pecegePayTransferController/PostApiV1PecegepayTransferCoursefinpersonpaymentid.ts";

export const postApiV1PecegepayTransferCoursefinpersonpaymentidPathParamsSchema =
  z.object({
    courseFinPersonPaymentId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1PecegepayTransferCoursefinpersonpaymentidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1PecegepayTransferCoursefinpersonpaymentid200Schema =
  z.boolean() as unknown as ToZod<PostApiV1PecegepayTransferCoursefinpersonpaymentid200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1PecegepayTransferCoursefinpersonpaymentid401Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayTransferCoursefinpersonpaymentid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1PecegepayTransferCoursefinpersonpaymentid500Schema =
  z.any() as unknown as ToZod<PostApiV1PecegepayTransferCoursefinpersonpaymentid500>;

export const postApiV1PecegepayTransferCoursefinpersonpaymentidMutationResponseSchema =
  z.lazy(
    () => postApiV1PecegepayTransferCoursefinpersonpaymentid200Schema,
  ) as unknown as ToZod<PostApiV1PecegepayTransferCoursefinpersonpaymentidMutationResponse>;
